import * as React from 'react'
import { useModal } from '@components/modals/use-modal'
import { useUpsellBookingDetailsRefresh } from '@modules/upselling/upsell-booking-details/use-upsellbooking-details-refresh'
import { ClientUser } from '@models/clients'
import { ButtonWithIcon } from '@components/button-with-icon'
import { UpsellBookingsDetailsProductsSaleBaseRow } from '@modules/upselling/upsell-booking-details/products/sale-card/upsell-bookings-details-products-sale-base-row'

interface Props {
  client: ClientUser
  name: string
}

export const UpsellBookingsSubscriptionContractProductSaleRow = ({ client, name }: Props): JSX.Element | null => {
  const { refresh } = useUpsellBookingDetailsRefresh()

  const [showSubscriptionContractSaleModal] = useModal(
    'SubscriptionContractCreateModal',
    { client },
    { onClose: refresh },
  )

  return (
    <UpsellBookingsDetailsProductsSaleBaseRow name={name}>
      <ButtonWithIcon
        icon="uil-plus font-16 lh-1"
        text="Sprzedaj"
        color="btn btn-green btn-tall"
        handleClick={showSubscriptionContractSaleModal}
      />
    </UpsellBookingsDetailsProductsSaleBaseRow>
  )
}
